<div class="row">
  <app-form-group label="Request made on behalf of">
    <app-select id="onBehalfOf" [(ngModel)]="exemption.onBehalfOf" (ngModelChange)="resetOnBehalfOfOther()"
                [options]="onBehalfOfOptions" required>
    </app-select>
  </app-form-group>
</div>
<div class="row">
  @if (exemption.onBehalfOf == 'Other') {
    <app-form-group label="Other specifically">
      <input id="onBehalfOfOther" [(ngModel)]="exemption.onBehalfOfOther" type="text"
             maxlength="30" class="form-control" required>
    </app-form-group>
  }
</div>

<div class="row">
  <app-form-group label="Name of applicant">
    <input [(ngModel)]="exemption.nameOfApplicant" id="nameOfApplicant" type="text"
           maxlength="30" class="form-control" required>
  </app-form-group>
</div>
<div class="row">
</div>

<div class="row">
  <app-form-group>
    <app-info class="formGroupLabel">
      <label>Email address of applicant</label>
      <div class="tooltipContent">Please provide an email address that is monitored at all times (24/7)</div>
    </app-info>
    <input [(ngModel)]="exemption.emailAddressOfApplicant" id="6" type="text" maxlength="256"
           class="form-control" required>
  </app-form-group>
</div>
<div class="row">
  <app-form-group label="Telephone number of applicant">
    <input [(ngModel)]="exemption.telephoneNumberOfApplicant" id="telephoneNumberOfApplicant"
           type="text" maxlength="30" class="form-control" required value="+31">
  </app-form-group>
</div>

<div class="row">
  <app-form-group>
    <app-info class="formGroupLabel">
      <label>Filled in truthfully</label>
      <div class="tooltipContent">The undersigned declares that the information in this request form has been filled in
        truthfully and that any explanatory notes and/or attachments reflect reality
      </div>
    </app-info>
    <app-yes-no [(ngModel)]="exemption.hasFormFilledTruthfully" id="hasFormFilledTruthfully" required></app-yes-no>
  </app-form-group>
</div>
<div class="row">
  <app-form-group>
    <label>Attachments</label>
    @if (this.getTooltipAttachment(exemption.exemptionType)) {
      <app-info class="formGroupLabel">
        <div class="tooltipContent">{{ this.getTooltipAttachment(exemption.exemptionType) }}</div>
      </app-info>
    }
    <div style="display: flex; gap: 10px;">
      <button style="flex: 1;" class="btn btn-secondary" role="button" (click)="uploadAttachments.click()"
              title="Upload exemption forms">
        <span class="fa fa-file-upload"></span>
        <input type="file" hidden
               accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf"
               (change)="upload(exemption, $event.target.files); $event.target.value = '';"
               [required]="attachmentRequired(exemption)" #uploadAttachments>
        Upload
      </button>
    </div>
    <br>
    @for (value of exemption.attachments; track value; let i = $index) {
      <div class="row_exemption_common">
        <input style="flex: 12;" type="text" [(ngModel)]="exemption.attachments[i]" class="form-control"
               disabled="true"/>
        <button style="flex: 1;" class="btn" (click)="delete(exemption, i)">
          <span class="fa fa-trash text-secondary"></span>
        </button>
      </div>
    }
  </app-form-group>
</div>
